module.exports = "/images/7f43e69-blue_background_title_1.png";